import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  LinearProgressBar,
  Modal,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
} from "../../../components/core";
import { BarCharts } from "../../../components/charts";
import { useApolloClient, useLazyQuery, useQuery } from "@apollo/client";
import {
  LOCKER_LIST_FOR_PEAK_HOURS,
  PACKAGE_DROPOFF_PEAK_HOURS,
  PARTNER_LIST_FOR_PEAK_HOURS,
} from "../../../constants/graphql/peak-reports-queries";
import { Label } from "recharts";
import {
  convertTo12HourFormat,
  customLabelFormatterForDropoff,
} from "../../../algorithms/timeformat";
import { formatDate, formatDateYYYYMMDD } from "../../../algorithms/date";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import {
  QUERY_COMPANY_BRANCHES,
  QUERY_COMPANY_NKCNAME,
  QUERY_LOCKER_TYPE,
} from "../../../constants/graphql/drop-off-graphql";
import { NEWEST_LOCKER_NAME_QUERY } from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import { maxDate } from "../drop-off-status";
import { useDispatch, useSelector } from "react-redux";
import { setTotalDoors } from "../../../features/package-dropoff-peak-hours/package-dropoff-peak-hours-report-slice";
import { Card } from "primereact/card";
import { Strings } from "../../../constants/strings";

function convertArrayToEpoch(array) {
  return array.map((obj) => {
    const [hours, period] = obj.hour.match(/\d+|[APMapm]{2}/g);
    const adjustedHours =
      period.toLowerCase() === "pm" && hours !== "12"
        ? +hours + 12
        : +hours % 12;
    const epochTime = new Date().setHours(adjustedHours, 0, 0, 0);

    return { ...obj, hour: epochTime };
  });
}
export default function PeakDropoffReportPage() {
  const client = useApolloClient();
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const dispatch = useDispatch();
  const totalDoors = useSelector(
    (state) => state.packageDropoffPeakHoursReport.totalDoors
  );

  console.log({ totalDoors });
  // local states
  const [header, setHeader] = React.useState("");
  const [loadingData, setLoadingData] = React.useState(false);
  const [noData, setNoData] = React.useState(false);
  const [searchData, setSearchData] = React.useState([]);
  const [lockerData, setLocketData] = React.useState([]);
  const [partnerData, setPartnerData] = React.useState([]);
  const [searchVariables, setSearchVariables] = React.useState({
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    dateStart: maxDate,
    dateEnd: new Date(),
    lockers: [],
    lockerTypeId: "-1",
    selectedPartnerCompany: "-1",
    selectedPartnerBranch: [],
  });
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [lockerType, setLockerType] = useState();
  const [allLockersSelected, setAllLockersSelected] = useState(false);
  const [partnerCompany, setPartnerCompany] = useState("");
  const [partnerBranch, setPartnerBranch] = useState([]);
  const [allBranchesSelected, setAllBranchesSelected] = useState(false);
  const [doorNumbers, setDoorNumbers] = React.useState({
    small: 0,
    medium: 0,
    large: 0,
    xl: 0,
  });

  // gql
  const lockerList = useQuery(LOCKER_LIST_FOR_PEAK_HOURS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });

  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
  const [fetchLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
        //   selectedLockerType: selectedLockerType,
      },
    }
  );
  const fetchCompanyName = useQuery(QUERY_COMPANY_NKCNAME, {
    variables: {
      operatorId: operatorId,
    },
  });
  const [fetchCompanyBranch, { data: companyBranchData }] = useLazyQuery(
    QUERY_COMPANY_BRANCHES,
    {
      variables: {
        operatorId: operatorId,
        //   selectedLockerType: selectedLockerType,
      },
    }
  );

  // handle changes

  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "lockers") {
      let tempLockers = [];
      value.forEach((element) => {
        tempLockers.push(element.value);
      });
      console.log(tempLockers);
      setSearchVariables((prev) => ({ ...prev, [name]: tempLockers }));
    } else {
      setSearchVariables((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateSearchVars = () => {
    if (
      searchVariables.lockerTypeId !== "-1" &&
      searchVariables.lockers.length === 0
    ) {
      setSearchData([]);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_search_criteria,
        message: Strings.popup_error_lockername,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    if (
      searchVariables.selectedPartnerCompany !== "-1" &&
      searchVariables.selectedPartnerBranch.length === 0
    ) {
      setSearchData([]);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_search_criteria,
        message: "Partner branch cannot be empty",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    } else {
      handleSearch();
    }
  };
  const handleSearch = async () => {
    let doorsList = {
      small: 0,
      medium: 0,
      large: 0,
      xl: 0,
    };

    headerValue();
    setLoadingData(true);
    const start = formatDateYYYYMMDD(searchVariables.dateStart);
    const end = formatDateYYYYMMDD(searchVariables.dateEnd);
    let tempSearchVar = { ...searchVariables };
    tempSearchVar.dateStart = start;
    tempSearchVar.dateEnd = end;

    if (searchVariables.lockers && searchVariables.lockers.length > 0) {
      tempSearchVar.lockers = searchVariables.lockers.map(
        (locker) => locker.value
      );
    } else {
      delete tempSearchVar.lockers;
    }

    if (
      searchVariables.selectedPartnerBranch &&
      searchVariables.selectedPartnerBranch.length > 0
    ) {
      tempSearchVar.partnerBranchIds =
        searchVariables.selectedPartnerBranch.map((branch) => branch.value);
    } else {
      delete tempSearchVar.selectedPartnerBranch;
    }

    try {
      const { data } = await client.query({
        query: PACKAGE_DROPOFF_PEAK_HOURS,
        variables: tempSearchVar,
      });

      let tempData = [];

      // NEW: Door totaling logic copied from first function
      data.packageDropoffPeakHours[0].doorSizes.forEach((element) => {
        console.log({ element });
        switch (element.size) {
          case "Small":
            doorsList.small = element.doors;
            break;
          case "Medium":
            doorsList.medium = element.doors;
            break;
          case "Large":
            doorsList.large = element.doors;
            break;
          case "XL":
            doorsList.xl = element.doors;
            break;
          default:
            break;
        }
      });

      data.packageDropoffPeakHours.forEach((element) => {
        let tempElement = {
          hour: convertTo12HourFormat(element.hour),
          Large: 0,
          Small: 0,
          XL: 0,
          Medium: 0,
        };
        element.doorSizes.forEach((doorElement) => {
          switch (doorElement.size) {
            case "Small":
              tempElement.Small = doorElement.packages;
              break;
            case "Medium":
              tempElement.Medium = doorElement.packages;
              break;
            case "Large":
              tempElement.Large = doorElement.packages;
              break;
            case "XL":
              tempElement.XL = doorElement.packages;
              break;
            default:
              break;
          }
        });
        tempData.push(tempElement);
      });

      console.log({ tempData, doorsList, data });
      setSearchData(tempData);
      setSearchVariables({
        ...searchVariables,
        dateEnd: searchVariables.dateEnd,
        dateStart: searchVariables.dateStart,
      });
      setLoadingData(false);
      const isAllDataZero = tempData.every(
        (item) =>
          item.Large === 0 &&
          item.Small === 0 &&
          item.XL === 0 &&
          item.Medium === 0
      );

      setNoData(isAllDataZero);
      console.log({ tempSearchVar, searchVariables });

      // NEW: Setting door numbers and dispatching total doors (copied from first function)
      setDoorNumbers(doorsList);
      dispatch(setTotalDoors(doorsList));
    } catch (error) {
      console.log(error);
    }
  };

  // use effects
  useEffect(() => {
    if (searchVariables.lockerTypeId !== "-1") {
      fetchLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: searchVariables.lockerTypeId,
        },
      });
    }
  }, [searchVariables.lockerTypeId, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLocketData(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = searchVariables.lockers;
    const allLockers = lockerData;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [searchVariables.lockers, lockerData]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerData.filter((locker) => locker.value !== 0);

      setSearchVariables({
        ...searchVariables,
        lockers: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerData]);

  useEffect(() => {
    if (fetchCompanyName.data) {
      let tempData = [];
      fetchCompanyName.data.partners.forEach((element, index) => {
        tempData.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      setPartnerCompany(tempData);
    }
  }, [fetchCompanyName.data]);

  useEffect(() => {
    if (searchVariables.selectedPartnerCompany !== "-1") {
      fetchCompanyBranch({
        variables: {
          operatorId: operatorId,
          selectedPartnerCompany: searchVariables.selectedPartnerCompany,
        },
      });
    }
  }, [searchVariables.selectedPartnerCompany, operatorId]);

  useEffect(() => {
    if (companyBranchData && companyBranchData.searchBranches) {
      const tempData = companyBranchData.searchBranches.map((element) => ({
        value: element.partnerBranchId,
        label: element.partnerBranch,
      }));

      // Add "All Branches" option
      if (!allBranchesSelected) {
        tempData.unshift({
          value: 0,
          label: "All Partner Branches",
        });
      }
      setPartnerBranch(tempData);
    }
  }, [companyBranchData, allBranchesSelected]);
  useEffect(() => {
    const selected = searchVariables.selectedPartnerBranch;
    const allBranches = partnerBranch;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllBranchesSelected(true);
    } else if (selected.length === 0) {
      setAllBranchesSelected(false);
    } else if (selected.length !== allBranches.length) {
      setAllBranchesSelected(false);
    } else {
      setAllBranchesSelected(true);
    }
  }, [searchVariables.selectedPartnerBranch, partnerBranch]);

  useEffect(() => {
    if (allBranchesSelected) {
      const branches = partnerBranch.filter((branch) => branch.value !== 0);

      setSearchVariables({
        ...searchVariables,
        selectedPartnerBranch: branches,
      });
    }
  }, [allBranchesSelected, partnerBranch]);

  //   old useeffects
  const headerValue = () => {
    console.log({ searchVariables, partnerBranch, lockerData });

    // Adapted logic for locker names
    let lockerNameText;
    if (searchVariables.lockers && searchVariables.lockers.length > 0) {
      // Check if all lockers are selected (excluding "All Lockers" option with value 0)
      const availableLockers = lockerData.filter(
        (locker) => locker.value !== 0
      );
      if (searchVariables.lockers.length === availableLockers.length) {
        lockerNameText = "ALL Lockers";
      } else {
        const lockerLabels = searchVariables.lockers
          .map((selectedLocker) => {
            const matchedLocker = lockerData.find(
              (item) => parseInt(item.value) === parseInt(selectedLocker.value)
            );
            return matchedLocker ? matchedLocker.label : null;
          })
          .filter((label) => label !== null);

        lockerNameText =
          lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
      }
    } else {
      lockerNameText = "ALL Lockers";
    }

    // Partner company logic
    const partnerCompanyText =
      searchVariables.selectedPartnerCompany &&
      searchVariables.selectedPartnerCompany !== "-1"
        ? (() => {
            const partner = partnerCompany.find(
              (x) => x.value === searchVariables.selectedPartnerCompany
            );
            return partner ? `of ${partner.name}` : "of ALL Partners";
          })()
        : "of ALL Partners";

    // Partner branch logic
    const partnerBranchText =
      searchVariables.selectedPartnerBranch &&
      searchVariables.selectedPartnerBranch.length !== 0
        ? `of branch ${searchVariables.selectedPartnerBranch
            .map((branch) => branch.label)
            .join(", ")}`
        : "and ALL Partner Branches";

    setHeader({
      title: "PACKAGE DROPOFF PEAK HOURS REPORT",
      details: `for ${lockerNameText} ${partnerCompanyText} ${partnerBranchText} from ${formatDate(
        searchVariables.dateStart
      )} to ${formatDate(searchVariables.dateEnd)}`,
    });
  };

  // Alternative cleaner version with better structure
  const headerValueCleaner = () => {
    console.log({ searchVariables, partnerBranch, lockerData });

    // Helper function to get locker names text
    const getLockerNamesText = () => {
      if (!searchVariables.lockers || searchVariables.lockers.length === 0) {
        return "ALL Lockers";
      }

      const availableLockers = lockerData.filter(
        (locker) => locker.value !== 0
      );
      if (searchVariables.lockers.length === availableLockers.length) {
        return "ALL Lockers";
      }

      const lockerLabels = searchVariables.lockers
        .map((selectedLocker) => {
          const matchedLocker = lockerData.find(
            (item) => parseInt(item.value) === parseInt(selectedLocker.value)
          );
          return matchedLocker?.label || null;
        })
        .filter(Boolean); // Removes null/undefined values

      return lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
    };

    // Helper function to get partner company text
    const getPartnerCompanyText = () => {
      if (
        !searchVariables.selectedPartnerCompany ||
        searchVariables.selectedPartnerCompany === "-1"
      ) {
        return "of ALL Partners";
      }

      const partner = partnerCompany.find(
        (x) => x.value === searchVariables.selectedPartnerCompany
      );
      return partner ? `of ${partner.name}` : "of ALL Partners";
    };

    // Helper function to get partner branch text
    const getPartnerBranchText = () => {
      if (
        !searchVariables.selectedPartnerBranch ||
        searchVariables.selectedPartnerBranch.length === 0
      ) {
        return "and ALL Partner Branches";
      }

      return `of branch ${searchVariables.selectedPartnerBranch
        .map((branch) => branch.label)
        .join(", ")}`;
    };

    setHeader({
      title: "PACKAGE DROPOFF PEAK HOURS REPORT",
      details: `for ${getLockerNamesText()} ${getPartnerCompanyText()} ${getPartnerBranchText()} from ${formatDate(
        searchVariables.dateStart
      )} to ${formatDate(searchVariables.dateEnd)}`,
    });
  };

  const handleFilterChange = (e, field) => {
    let value = e.target.value;
    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }

    if (field === "lockerTypeId") {
      setSearchVariables({
        ...searchVariables,
        [field]: value,
        lockers: [],
      });
    } else if (field === "selectedPartnerCompany") {
      setSearchVariables({
        ...searchVariables,
        [field]: value,
        selectedPartnerBranch: [],
      });
    } else {
      setSearchVariables({
        ...searchVariables,
        [field]: value,
      });
    }
  };

  const customLegendFormatter = (value) => {
    let stringVal = "";
    switch (value) {
      case "Small":
        stringVal = `${value} - ${doorNumbers.small}`;
        break;
      case "Medium":
        stringVal = `${value} - ${doorNumbers.medium}`;
        break;
      case "Large":
        stringVal = `${value} - ${doorNumbers.large}`;
        break;
      case "XL":
        stringVal = `${value} - ${doorNumbers.xl}`;
        break;
      default:
        break;
    }
    return stringVal; // Custom formatting for legend items
  };

  return (
    <ContentContainer containerTitle={"Package Dropoff Peak Hours Report"}>
      <h2 className={"font-bold"}>Locker:</h2>
      <div className={"grid grid-cols-6 w-full gap-y-2"}>
        <p className="col-span-1">Locker Type:</p>
        <Select
          items={lockerType}
          className={"col-span-3"}
          value={searchVariables.lockerTypeId}
          defaultOption={{ value: "-1", name: "-- ALL--" }}
          onChange={(event) => {
            handleFilterChange(event, "lockerTypeId");
          }}
        />
        <div className="col-span-2"></div>

        <p className="col-span-1">Locker Name:</p>
        <MultiSelect
          className={"col-span-3"}
          items={lockerData}
          value={searchVariables.lockers}
          placeholder={`${
            searchVariables.lockerTypeId === "-1" ? "ALL Lockers" : "Select..."
          }`}
          disabled={searchVariables.lockerTypeId === "-1"}
          onChange={(event) => {
            handleFilterChange(event, "lockers");
          }}
        />
      </div>

      <h2 className={"font-bold"}>Partner:</h2>
      <div className={"grid grid-cols-6 w-full items-center gap-y-2"}>
        <p className="col-span-1">Partner Company:</p>
        <Select
          items={partnerCompany}
          className={`col-span-3`}
          value={searchVariables.selectedPartnerCompany}
          defaultOption={{ value: "-1", name: "-- ALL --" }}
          onChange={(event) => {
            handleFilterChange(event, "selectedPartnerCompany");
          }}
        />
        <div className="col-span-2"></div>

        <p>Partner Branch:</p>
        <MultiSelect
          items={partnerBranch}
          className={`col-span-3`}
          value={searchVariables.selectedPartnerBranch}
          placeholder={`${
            searchVariables.selectedPartnerCompany === "-1"
              ? "ALL Partner Branches"
              : "Select..."
          }`}
          disabled={
            searchVariables.selectedPartnerCompany !== "-1" ? false : true
          }
          onChange={(event) => {
            handleFilterChange(event, "selectedPartnerBranch");
          }}
        />
      </div>

      <p className="font-bold">Date range:</p>
      {/* <DateRangePicker
				className={"w-1/2 mb-2"}
				onChange={handleChange}
				startDateName="dateStart"
				endDateName="dateEnd"
				startDate={searchVariables.dateStart}
				endDate={searchVariables.dateEnd}
			/> */}
      <PrimereactDateRange
        className={"w-1/2 mb-2"}
        onChange={handleChange}
        startDateName="dateStart"
        endDateName="dateEnd"
        readOnlyInput={true}
        max={new Date()} // Today's date as the maximum
        min={new Date("2021-01-01")}
        startDate={searchVariables.dateStart}
        endDate={searchVariables.dateEnd}
      />

      <div className="grid grid-cols-2 w-1/2 gap-y-2">
        <div></div>
        <u
          className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
          onClick={() => {
            setSearchVariables({
              ...searchVariables,
              dateStart: maxDate,
              dateEnd: new Date(),
              lockers: [],
              lockerTypeId: "-1",
              selectedStatus: "-1",
              selectedPartnerCompany: "-1",
              selectedPartnerBranch: [],
            });
          }}
        >
          <i className="fas fa-undo my-auto"></i>
          <p className="ml-1">Reset</p>
        </u>
      </div>

      <Button
        className={"p-2 mb-4"}
        value={"Search"}
        onClick={validateSearchVars}
      />
      <LinearProgressBar label="" open={loadingData} />
      {noData && <NoDataFoundTemplate width={56} height={56} />}
      {noData === false && searchData.length > 0 && (
        <div className="px-4">
          <Card>
            <BarCharts
              xAxisBar={[
                { dataKey: "Small", fill: "#8884d8" },
                { dataKey: "Medium", fill: "#82ca9d" },
                { dataKey: "Large", fill: "#3e3e3e" },
                // { dataKey: "XL", fill: "#FECD08" },
              ]}
              dataKey="hour"
              data={searchData}
              legendLayout="vertical"
              legendVerticalAlign="top"
              xAxislabel={<Label value="" offset={0} position="insideBottom" />}
              yAxisLabel={{
                value: "Packages",
                angle: -90,
                position: "insideLeft",
              }}
              customTooltipLabelFormatter={customLabelFormatterForDropoff}
              customLegendLayoutFormatter={customLegendFormatter}
              header={header}
            />
            <div className="bg-primary-primaryYellow text-center mt-14">
              <p className="font-bold text-xl">{header.title}</p>
              <p className="font-bold">{header.details}</p>
            </div>
            <DataTable
              value={convertArrayToEpoch(searchData)}
              stripedRows
              showGridlines
              tableStyle={{
                minWidth: "50rem",
              }}
              style={{
                borderLeftWidth: 2,
                borderBottomWidth: 2,
                borderRightWidth: 2,
                borderColor: "#E6E6E6",
              }}
            >
              <Column
                field={"hour"}
                sortable
                header={"Hours"}
                body={timeSpanTemplate}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              ></Column>
              <Column
                field={"Small"}
                sortable
                header={"Small"}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
                body={(rowData, data) => {
                  return (
                    <div>
                      {`${rowData.Small} of
				 ${totalDoors.small}`}
                    </div>
                  );
                }}
              ></Column>
              <Column
                field={"Medium"}
                sortable
                header={"Medium"}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
                body={(rowData, data) => {
                  return (
                    <div>
                      {`${rowData.Medium} of
				 ${totalDoors.medium}`}
                    </div>
                  );
                }}
              ></Column>
              <Column
                field={"Large"}
                sortable
                header={"Large"}
                headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
                body={(rowData, data) => {
                  return (
                    <div>
                      {`${rowData.Large} of
				 ${totalDoors.large}`}
                    </div>
                  );
                }}
              ></Column>
            </DataTable>
          </Card>
        </div>
      )}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}

function createTimeRange(time) {
  const startEpoch = convert12HourToEpoch(`${time} AM`);
  const endEpoch = convert12HourToEpoch(`${time} PM`);

  const startTime = convertEpochTo12Hour(startEpoch);
  const endTime = convertEpochTo12Hour(endEpoch).replace(":00", ":59");

  return `${startTime} to ${endTime}`;
}

function convertEpochTo12Hour(epoch) {
  const dateObj = new Date(epoch);
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  // Calculate AM/PM and adjust hours
  const period = hours >= 12 ? "PM" : "AM";
  const adjustedHours = hours % 12 || 12;

  // Format the time as 'h:mm AM/PM'
  const timeString = `${adjustedHours}:${minutes
    .toString()
    .padStart(2, "0")} ${period}`;

  return timeString;
}

function convert12HourToEpoch(timeString) {
  const [hours, period] = timeString.match(/\d+|[APMapm]{2}/g);
  const adjustedHours =
    period.toLowerCase() === "pm" && hours !== "12" ? +hours + 12 : +hours % 12;
  return new Date().setHours(adjustedHours, 0, 0, 0);
}
const timeSpanTemplate = (rowData, data) => {
  return (
    <p>
      {createTimeRange(convertEpochTo12Hour(rowData[data.column.props.field]))}
    </p>
  );
};
